<section class="about-section section-padding vw-100 overflow-hidden" [ngClass]="{'pt-0': isPage}">
  <div class="container container-max">
    <div class="row g-5">
      <div class="col-md-6">
        <span class="section-subtitle-pill">about cac-bor</span>
        <h2 class="heading-color-1 section-title mt-2 mb-4">Empowering Transparency Under CAMA 2020</h2>
        <div class="fs-15">
          <p class="pb-3">The Corporate Affairs Commission has built a register for Nigeria Beneficiary Ownership in accordance with international standard of Beneficiary Ownership Data Standards (BODS) under the guidance of World Bank. This portal provides search function and information on Persons with Significant Control (PSC).</p>
          <p class="pb-3">It also provides an Enterprise Service Bus (ESB) gateway for data exchange in accordance with BODS in in JSON format.</p>
          <p class="pb-3">This service will provide the module for data exchange between CRP and external applications/databases like Global Beneficiary Ownership Register G-BOR.</p>
          <p class="pb-3">This document highlights the detailed information of persons with significant control currently collected by CAC-BOR applications and stored in the register database.</p>
          <p class="pb-3">The data in the database forms the basis for data exchange. Any data exchange with external systems like Open Ownership will be communicated via a standard REST service, governed by standard protocol of CAC Enterprise Service Bus.</p>
        </div>
      </div>
      <div class="col-md-6">
        <ul class="list-unstyled d-flex flex-column gap-2 pt-md-5">
          <li class="about-item">
            <span class="icon-wrapper"><iconify [name]="'lucide:lock'" /></span>
            <div class="flex-grow-1">
              <h3 class="fs-18 fw-semibold heading-font heading-color-1 mb-2">Combating Corruption</h3>
              <p class="fs-15 line-height-150p">Preventing the use of shell companies for money laundering and public procurement inflation.</p>
            </div>
          </li>
          <li class="about-item">
            <span class="icon-wrapper"><iconify [name]="'lucide:briefcase'" /></span>
            <div class="flex-grow-1">
              <h3 class="fs-18 fw-semibold heading-font heading-color-1 mb-2">Ease of Doing Business</h3>
              <p class="fs-15 line-height-150p">Providing instant corporate verification for international trade and domestic investments.</p>
            </div>
          </li>
          <li class="about-item">
            <span class="icon-wrapper"><iconify [name]="'lucide:globe'" /></span>
            <div class="flex-grow-1">
              <h3 class="fs-18 fw-semibold heading-font heading-color-1 mb-2">International Standards Integration</h3>
              <p class="fs-15 line-height-150p">Exchanging critical data with global frameworks like Open Ownership and FATF compliant portals.</p>
            </div>
          </li>
          <li class="about-item bg-primary" style="color: var(--primary-text-color)!important;">
            <div class="pt-2"><iconify [name]="'lucide:shield'" [size]="22" /></div>
            <p class="fs-15 line-height-150p flex-grow-1">"Every company shall, within 30 days of acquisition or changes, notify the Commission of the details of its Persons with Significant Control." — Section 119, CAMA 2020.</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
